import React from "react";
import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import Media from "../../media";

const PageLoader = ({ isNoBG = false }) => {
  const { cloudinaryBase, envVersion, currentSeasonYear } = useCloudinaryData();
  return (
      <div
        className={`si-pageloader__wrap ${
          isNoBG ? "si-pageloader__wrap--noBg" : ""
        }`}
      >
        <div className="si-pageloader__icon">
          <Media
            imgSrc={`https://media.formula1.com/image/upload/v1751548229/Fantasy/2025/images/loader.png`}
            imgAlt="loader"
          />
        </div>
      </div>
  );
};

export default PageLoader;
